export const DOWNLOAD_APP_LINKS = {
	APP_STORE: 'https://apps.apple.com/pl/app/moje-zdrowie/id1598979898?l=pl',
	GOOGLE_PLAY:
		'https://play.google.com/store/apps/details?id=com.utopiaultimate.pozplus.zdrowie&gl=PL'
};
